import { CircleX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

/**
 * Why review rejected a creative and how to get it serving again. Goes at the
 * top of the creative page, beside the validation warnings.
 */
export function CreativeRejectedAlert({ reason }: { reason?: string }) {
  const { t } = useTranslation()
  return (
    <Alert variant="destructive">
      <CircleX />
      <AlertTitle>
        {reason
          ? t('creativeStates.rejected.titleWithReason', {
              reason: t(`creativeStates.rejected.reasons.${reason}.name`, { defaultValue: reason }),
            })
          : t('creativeStates.rejected.title')}
      </AlertTitle>
      <AlertDescription>
        {reason && <p>{t(`creativeStates.rejected.reasons.${reason}.explanation`, { defaultValue: '' })}</p>}
        <p>{t('creativeStates.rejected.resubmit')}</p>
      </AlertDescription>
    </Alert>
  )
}
